import { IChoiceGroupStyles } from "@fluentui/react";

export const themeChoiceStyles: Partial<IChoiceGroupStyles> = {
  flexContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 15,
  },
};
